import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';

import { BreadcrumbWrapper, Crumb } from '@/components/Breadcrumbs/BreadcrumbWrapper';
import { useAppSelector } from '@/redux/hooks';
import {
    getCatalogSellerId,
    getCatalogSellerName,
    getCatalogTitle,
} from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getSellerUrl } from '@/utils/urls';

type Props = {
    catalogId: number;
};

const CatalogPageBreadcrumbs = ({ catalogId }: Props) => {
    const { formatMessage } = useIntl();
    const sellerId = useAppSelector((state) => getCatalogSellerId(state, catalogId));
    const name = useAppSelector((state) => getCatalogSellerName(state, catalogId));
    const title = useAppSelector((state) => getCatalogTitle(state, catalogId));
    const sellerUrl = getSellerUrl(sellerId, name);

    const crumbs = [
        { label: formatMessage({ id: 'online_auctions' }), link: '/' },
        { label: name, link: sellerUrl },
        { label: title },
    ] as Crumb[];

    return <BreadcrumbWrapper crumbs={crumbs} />;
};

export default React.memo<Props>(CatalogPageBreadcrumbs);
